import Lookup from 'src/componentes/select-async';
import FormulaEdit from 'src/paginas/formula/index';
import FormulaList from 'src/paginas/formula/formula-padrao/view';

const FormulaPadraoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="descricao"
      showSearch
      clearable={true}
      url="/FormulaLookup"
      editComponent={FormulaEdit}
      searchComponent={FormulaList}
      {...props}
    />
  );
};

export default FormulaPadraoLookup;
